
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import React from 'react';

export const Footer: React.FC = () => {
    return (
        <footer className="text-center py-4 px-8 border-t border-stone-100 dark:border-white/5 mt-auto bg-white dark:bg-[#0A0B0F]">
            <p className="text-[10px] text-stone-400 dark:text-stone-600 font-mono uppercase tracking-[0.2em]">
                &copy; 2026 Ghost Network. Encrypted & Secured.
            </p>
        </footer>
    );
};
